<template>
  <div>
    <!-- score-description -->
    <label for="score-description" class="mb-u4"> Description </label>

    <base-text-editor
      id="score-description"
      ref="input__score-description"
      v-model="form.score_description"
      name="score-description"
      class="input__score-description"
      :disabled="isSaving"
      :editor-options="editorOptions"
    ></base-text-editor>

    <!-- button -->
    <div class="divider mt-u17" />
    <div class="d-flex mt-u4">
      <b-button variant="success" :disabled="isSaving" @click="save">
        <b-spinner v-if="isSaving" style="width: 1rem; height: 1rem" />
        <div v-else>Save</div>
      </b-button>
      <b-button variant="link" class="ml-u1" @click="goToPreviousPage">
        Back to previous page
      </b-button>
    </div>
  </div>
</template>

<script>
import BaseTextEditor from '../base-components/BaseTextEditor';

export default {
  components: {
    BaseTextEditor
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        score_description: ''
      })
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        score_description: ''
      },
      editorOptions: {
        // modules: {
        //   toolbar: [
        //     "bold",
        //     "italic",
        //     "underline",
        //     { header: 1 },
        //     { header: 2 },
        //     { list: "ordered" },
        //     { list: "bullet" },
        //     "link",
        //   ],
        // },
        placeholder: 'Insert your assessment instruction'
      }
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.form.score_description = this.data.score_description;
    },

    async save() {
      this.$emit('save', this.form);
    },

    async cancel() {
      this.$emit('cancel');
    },

    goToPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style></style>
